// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as AdjustFareRepo from "./AdjustFareRepo.bs.js";
import * as DummyAdjustFareRepo from "./DummyAdjustFareRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyAdjustFareRepo.AdjustFareRepo;
  } else {
    return AdjustFareRepo.AdjustFareRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
